import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import ProteinComplexPreview from 'molbio/aa-sequences/complex/AaSequenceComplexPreview';
import * as navigation from 'Navigation';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

class ProteinComplexPreviewTabState extends navigation.TabState {
  constructor({proteinIds}: {proteinIds: Array<string>}) {
    super();
    this.set('proteinIds', proteinIds);
  }

  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'AA Sequence Preview',
      closeable: true,
    };
  }
}

class ProteinComplexPreviewTabView extends Backbone.View<ProteinComplexPreviewTabState> {
  constructor({model}: {model: ProteinComplexPreviewTabState}) {
    super();
    this.model = model;
  }

  override render(): this {
    renderToDOM(<ProteinComplexPreview proteinIds={this.model.get('proteinIds')} />, this.el);
    return this;
  }

  override remove(): this {
    ReactDOM.unmountComponentAtNode(this.el);
    super.remove();
    return this;
  }
}

ProteinComplexPreviewTabView.prototype.className = 'buffer-tab buffer-tab-reset buffer-tab--no-padding';

export {ProteinComplexPreviewTabState as tabState, ProteinComplexPreviewTabView as tabView};
